// extracted by mini-css-extract-plugin
module.exports = {"row":"_3334bcf0","item":"_d1931d0f","link":"_deefdeba","badge":"_f5c02a9f","badgeInner":"_56ef7ca1"};